module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }